import React from 'react';
import {StandardProps} from '..';

export type CloseIconProps = StandardProps<React.HTMLAttributes<HTMLOrSVGElement>>;

export function CloseIcon(props: CloseIconProps) {
  return (
    <svg
      viewBox="0 0 20.7 20.7"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.7,20.7c-0.3,0-0.5-0.1-0.7-0.3l-8.6-8.6l-8.6,8.6c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4l8.6-8.6L0.3,1.7
	c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l8.6,8.6L19,0.3c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-8.6,8.6l8.6,8.6c0.4,0.4,0.4,1,0,1.4
	C20.2,20.6,19.9,20.7,19.7,20.7z"
      />
    </svg>
  );
}

export default CloseIcon;